<template>
  <base-modal :body_class="['pb-0']">
    <media-upload
      ref="form"
      v-model="form"
      :files.sync="files"
      @success="success"
      @remove="remove"
    />
    <template slot="footer-cancel" slot-scope="{ close }">
      <i-button size="large" @click="close()" ref="close">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
    </template>
    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save()">
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import MediaUpload from '@pbx/components/media/form/upload';
  import { MediaService } from '@pbx/services/MediaService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      BaseModal,
      MediaUpload
    },

    data: () => ({
      is_loading: false,
      files: [],
      form: [],
      id: [],
      trigger: false
    }),
    
    methods: {
      ...mapActions('pbx/media/table', ['getAsyncData']),
      save() {
        this.trigger = true;
        this.$refs.close.$el.click();
        this.getAsyncData();
      },
      success(e) {
        this.id.push(e.id)
      },
      remove(e) {
        this.id.splice(this.id.indexOf(e), 1)
      }
    },
    beforeDestroy() {
      if(!this.trigger && this.id.length) {
        for( let i in this.id) {
          MediaService.removeItem(this.id[i])
        }
      }
    }
  };
</script>
